module.exports = fox._r("images/views_eye.gif", __webpack_public_path__ + "images/views_eye.gif");


//////////////////
// WEBPACK FOOTER
// ./images/views_eye.gif
// module id = 1136
// module chunks = 4